<!--Login Page Starts-->
<section id="login">
  <div class="container-fluid">
    <div class="row full-height-vh">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="card gradient-indigo-purple text-center width-400">
          <div class="card-img overlap">
            <img alt="element 06" class="mb-1" src="assets/img/portrait/avatars/avatar-10.png" width="190">
          </div>
          <div class="card-body">
            <div class="card-block">
              <h2 class="white">Авторизация</h2>
              <form novalidate="" (ngSubmit)="onSubmit()" #f="ngForm" *ngIf="!lockForm">
                <div class="form-group">
                  <div class="col-md-12">
                    <input type="text" class="form-control" name="iLogin" id="iLogin" placeholder="Логин" ngModel required>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-md-12">
                    <input type="password" class="form-control" name="iPass" id="iPass" placeholder="Пароль" ngModel required>
                  </div>
                </div>
                <ng-container *ngIf="error">
                  <div class="form-group text-warning">
                    <span>Неправильный логин или пароль. Попробуйте еще раз.</span>
                  </div>
                </ng-container>
                <div class="form-group">
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-pink btn-block btn-raised">Войти</button>
                    <!-- button type="button" class="btn btn-secondary btn-block btn-raised">Отмена</button -->
                  </div>
                </div>
              </form>
              <app-data-loader *ngIf="lockForm"></app-data-loader>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Login Page Ends-->
